import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChartNoAxesCombined } from 'lucide-react';
import { useAuth } from '@/context/AuthProvider';
export default function ReportEntryCard() {
  const { user } = useAuth();
  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  const allowed = user?.is_platform_admin === true || ['admin', 'developer', 'company_director'].includes(user?.role) ||
    permissions.some(p => /^report\.(procurement|inventory|operational|finance)\.view$/.test(p));
  if (!allowed) return null;
  return <section className="rounded-2xl border border-cyan-400/20 bg-slate-950 p-6 text-slate-100">
    <div className="flex flex-wrap items-center justify-between gap-5">
      <div className="max-w-2xl"><p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-cyan-300"><ChartNoAxesCombined size={16}/>Business reporting</p>
        <h2 className="mt-2 text-xl font-semibold">Review a period across your operations</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-400">Compare verified purchasing and operational figures, review unit results, and see the financial data that still needs to be connected.</p></div>
      <Link to="/reports/business" className="inline-flex items-center gap-2 rounded-lg bg-cyan-300 px-4 py-3 text-sm font-semibold text-slate-950 hover:bg-cyan-200">Open unit report<ArrowUpRight size={16}/></Link>
    </div>
    <p className="mt-4 border-t border-white/10 pt-3 text-xs text-slate-400">Complete profit, revenue and budget figures require financial setup. The report shows their current data readiness.</p>
  </section>;
}
